import apiClientNotifications from "@/shared/api/apiClientNotifications";

/**
 * GET /  — list of notifications.
 * @param {import('../model/types').ListParams} [params]
 * @param {{ signal?: AbortSignal }} [opts]
 * @returns {Promise<import('../model/types').ListResponse>}
 */
export async function listNotifications(params = {}, opts = {}) {
  const cleaned = pruneParams(params);
  const res = await apiClientNotifications.get("/", {
    params: cleaned,
    paramsSerializer: { indexes: null },
    signal: opts.signal,
  });
  return res.data;
}

/**
 * GET /{uid} — auto marks as read.
 * @param {string} uid
 * @returns {Promise<import('../model/types').Notification>}
 */
export async function getNotification(uid) {
  const res = await apiClientNotifications.get(`/${encodeURIComponent(uid)}`);
  return res.data;
}

/**
 * GET /counter — { unread }
 * @returns {Promise<{ unread: number }>}
 */
export async function getCounter() {
  const res = await apiClientNotifications.get("/counter");
  return res.data;
}

/**
 * GET /categories — { categories: [{ key, title, count }] }
 * @returns {Promise<{ categories: import('../model/types').Category[] }>}
 */
export async function getCategories() {
  const res = await apiClientNotifications.get("/categories");
  return res.data;
}

/**
 * PATCH /{event_uuid}/read — mark single read.
 * @param {string} eventUuid
 * @returns {Promise<import('../model/types').Notification>}
 */
export async function markRead(eventUuid) {
  const res = await apiClientNotifications.patch(
    `/${encodeURIComponent(eventUuid)}/read/`
  );
  return res.data;
}

/**
 * PATCH /read-all — mark all read.
 * @returns {Promise<{ updated: number }>}
 */
export async function markAllRead() {
  const res = await apiClientNotifications.patch("/read-all");
  return res.data;
}

function pruneParams(params) {
  const out = {};
  for (const [k, v] of Object.entries(params || {})) {
    if (v === undefined || v === null || v === "") continue;
    if (Array.isArray(v) && v.length === 0) continue;
    out[k] = v;
  }
  return out;
}
